import React, { Component } from 'react';
import RothButton from '../components/RothButton.js';
import RothTextInput from '../components/RothTextInput.js';
import RothCheckBox from '../components/RothCheckBox.js';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import FontAwesome from 'react-fontawesome';

import img_logoRed from '../img/logo_red.png';

export default class WelcomePage extends Component {
  style = {};

  render = () => (
    <div className="content">
      <div className="inner">
        <div>
          <DropDownMenu
            ref={e => (this.langDropDown = e)}
            value={this.props.user.lang}
            onChange={(event, index, value) => this.props.changeUserParam('lang', value)}
            style={{ verticalAlign: 'middle' }}
            labelStyle={{ paddingLeft: '76px', width: '0px', color: 'transparent' }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            targetOrigin={{ vertical: 'top', horizontal: 'right' }}
            iconButton={
              <FontAwesome name={'language'} style={{ fontSize: '15px', height: '48px', verticalAlign: 'sub', marginLeft: '36px' }} />
            }
            iconStyle={{ fontSize: '20px', paddingRight: '80px', paddingTop: '7px' }}
          >
            <MenuItem value={'en'} primaryText={this.props.text('menu', 'en')} />
            <MenuItem value={'fi'} primaryText={this.props.text('menu', 'fi')} />
            <MenuItem value={'sv'} primaryText={this.props.text('menu', 'sv')} />
            <MenuItem value={'dk'} primaryText={this.props.text('menu', 'dk')} />
            <MenuItem value={'no'} primaryText={this.props.text('menu', 'no')} />
          </DropDownMenu>
          <span style={{ verticalAlign: 'sub', marginLeft: '-70px' }}>{this.props.text('menu', this.props.user.lang)}</span>
        </div>
        <div style={{ textAlign: 'right', padding: '26px 36px' }}>
          <img style={{ height: '64px' }} src={img_logoRed} alt={img_logoRed} />
        </div>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '30px', textAlign: 'left', margin: '10px 30px 10px 30px' }}>{this.props.text('welcome', 'h1')}</h1>
          <h2 style={{ fontSize: '20px', textAlign: 'left', margin: '10px 30px 70px 30px' }}>{this.props.text('welcome', 'desc')}</h2>
          <div style={{ padding: '35px' }}>
            <RothTextInput
              param="username"
              value={this.props.user.username}
              fn={this.props.changeUserParam}
              placeholder={this.props.text('welcome', 'i1')}
            />
            <RothTextInput
              param="password"
              type="password"
              value={this.props.user.password}
              fn={this.props.changeUserParam}
              placeholder={this.props.text('welcome', 'i2')}
            />
            <div style={{ width: '100%', margin: '25px auto 100px auto', display: 'flex', justifyContent: 'space-between' }}>
              <table style={{ fontSize: '14px', width: '100%' }}>
                <tbody>
                  <tr>
                    <td>
                      <RothCheckBox
                        param="rememberPassword"
                        value={this.props.user.rememberPassword}
                        fn={this.props.changeUserParam}
                        style={{ marginLeft: '-6px' }}
                      >
                        {this.props.text('welcome', 'i3').replace(/ /g, '\u00a0')}
                      </RothCheckBox>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <RothButton
                        style={{ padding: '4px 0px 0px 0px', fontSize: '14px' }}
                        type="text"
                        fn={this.props.changePage}
                        value="forgot"
                      >
                        {this.props.text('welcome', 'i4').replace(/ /g, '\u00a0')}
                      </RothButton>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <RothButton disabled={this.props.responseStatus === 'waiting'} type="wide" fn={this.props.login}>
            {this.props.text('welcome', 'b1')}
          </RothButton>
          <RothButton disabled={!this.props.isPageAllowed('newUser')} type="text" fn={this.props.changePage} value="newUser">
            {this.props.text('welcome', 'b2')}
          </RothButton>
          <div style={{ paddingTop: '200px' }} />
        </div>
        <div />
      </div>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/WelcomePage.js
 **/